import { Link } from 'react-router-dom'
import { CheckCircle2, Mail, Sparkles, Download } from 'lucide-react'
import { useSalesLinkStore } from './store'

export function SalesLinkSuccessPage() {
  const planName = useSalesLinkStore((s) => s.lastContractedPlanName)
  const amount = useSalesLinkStore((s) => s.lastAmountPaid)
  const method = useSalesLinkStore((s) => s.lastPaymentMethod)
  const boletoUrl = useSalesLinkStore((s) => s.lastBoletoUrl)
  const seller = useSalesLinkStore((s) => s.payload?.seller)
  const isBoleto = method === 'BOLETO'

  return (
    <div className="lp-root min-h-dvh bg-gray-50 flex items-center justify-center px-4 py-10">
      <div className="bg-white rounded-3xl border border-gray-200 p-8 sm:p-10 max-w-lg w-full text-center lp-fade-in shadow-card-lg">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-50 mb-5">
          <CheckCircle2 size={36} className="text-emerald-600" />
        </div>
        <h1 className="text-[#243c4f] text-2xl sm:text-[28px] font-bold leading-tight">
          Seu plano foi contratado <span className="text-[#f07d00]">com sucesso!</span>
        </h1>

        {planName && (
          <p className="text-[#56758d] text-sm mt-3">
            Você acaba de aderir ao <strong className="text-[#243c4f]">{planName}</strong>
            {amount != null && (
              <>
                {' '}por{' '}
                <strong className="text-[#243c4f]">
                  R$ {amount.toFixed(2).replace('.', ',')}/mês
                </strong>
              </>
            )}
            .
          </p>
        )}

        {/* Boleto: link de download. Cartão: apenas mensagem de confirmação. */}
        {isBoleto && boletoUrl ? (
          <div className="mt-6 p-4 rounded-xl bg-amber-50 border border-amber-200 text-left">
            <div className="text-[13px] text-[#56758d] mb-3">
              Geramos o seu <strong className="text-[#243c4f]">boleto da primeira mensalidade</strong>.
              Sua adesão será confirmada após o pagamento.
            </div>
            <a
              href={boletoUrl}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 h-11 px-5 rounded-lg bg-[#243c4f] hover:bg-[#1a2d3e] text-white text-sm font-semibold transition w-full"
            >
              <Download size={16} /> Baixar boleto
            </a>
          </div>
        ) : (
          <div className="mt-6 p-4 rounded-xl bg-gray-50 border border-gray-100 flex items-start gap-3 text-left">
            <Mail size={18} className="text-[#046fb7] mt-0.5 shrink-0" />
            <div className="text-[13px] text-[#56758d]">
              {method === 'CARTÃO DE CRÉDITO'
                ? <>O pagamento no <strong className="text-[#243c4f]">cartão</strong> foi aprovado e sua assinatura mensal já está ativa. Em breve você receberá um e-mail com sua carteirinha digital.</>
                : <>Aguarde o envio de um <strong className="text-[#243c4f]">e-mail</strong> com sua carteirinha digital e instruções de uso do plano.</>}
            </div>
          </div>
        )}

        {seller && (
          <div className="mt-4 p-4 rounded-xl bg-[#243c4f]/5 text-left">
            <div className="text-[10px] uppercase tracking-wider text-[#56758d] font-semibold mb-1">
              Seu consultor
            </div>
            <div className="text-sm font-semibold text-[#243c4f]">{seller.name}</div>
            {seller.whatsapp && (
              <a
                href={`https://wa.me/55${seller.whatsapp.replace(/\D+/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs text-[#046fb7] hover:underline mt-1 inline-block"
              >
                Falar no WhatsApp
              </a>
            )}
          </div>
        )}

        <Link
          to="/"
          className="mt-7 inline-flex items-center justify-center gap-2 h-12 px-6 rounded-lg bg-[#f07d00] hover:bg-[#e67300] text-white text-sm font-semibold transition w-full"
        >
          <Sparkles size={14} /> Voltar à página inicial
        </Link>
      </div>
    </div>
  )
}
